import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { API_GET } from "../../helpers/api";
import * as actions from "../actions/objections";
import moment from "moment";

import {
  GET_OBJECTIONS_ORDER_MATCH_REQUESTED,
  GET_OBJECTIONS_REQUESTED,
  GET_OBJECTIONS_HISTORY_REQUESTED,
} from "../types";

function* watchGetObjectionsOrderMatch() {
  yield takeLatest(
    GET_OBJECTIONS_ORDER_MATCH_REQUESTED,
    getObjectionsOrderMatch
  );
}
function* watchGetObjectionsRequested() {
  yield takeLatest(GET_OBJECTIONS_REQUESTED, getObjections);
}
function* watchGetObjectionsHistoryRequested() {
  yield takeLatest(GET_OBJECTIONS_HISTORY_REQUESTED, getObjectionsHistory);
}

function* getObjectionsOrderMatch(action) {
  try {
    const organizationId = action.payload;
    const res = yield call(apiGetObjectionsOrderMatch, organizationId);

    const matches = res.data.items.reduce((acc, value) => {
      acc.push({
        id: value.bundleId,
        orderId:
          value.buyOrganizationId === organizationId
            ? value.buyOrderGroupId
            : value.sellOrderGroupId,
        contractName: value?.contractName,
        matchTotalAmount: value?.matchBundle?.matchTotalAmount,
        orderTotalBuyAmount: value?.matchBundle?.orderTotalBuyAmount,
        objectionAble: value?.objectionAble,
        buyerOrganization: value.sellOrderGroupId,
        price:
          value.buyOrganizationId === organizationId
            ? value.orderBuyPrice
            : value.orderSellPrice,
        matchPrice: value.matchPrice,
        quantity:
          value.buyOrganizationId === organizationId
            ? value.orderTotalBuyAmount
            : value.orderTotalSellAmount,
        matchQuantity: value.matchTotalAmount,
        sellerOrganization: value.sellOrganizationName,
        matchDate: value.matchedAt,
        matchStatus: value.matchStatus.text,
        offerDate:
          value.buyOrganizationId === organizationId
            ? value.matchList[0]?.buyOrder?.givenAt
            : value.matchList[0]?.sellOrder.givenAt,
        orderType: value.buyOrganizationId === organizationId ? "BUY" : "SELL",
        // transferedCertificateId: value.transferedCertificateId,
        organizationName:
          value.buyOrganizationId === organizationId
            ? value.buyOrganizationName
            : value.sellOrganizationName,
        userName:
          value.buyOrganizationId === organizationId
            ? value.matchList[0]?.buyOrder.createdBy
            : value.matchList[0]?.sellOrder.createdBy,
      });
      return acc;
    }, []);
    yield put(actions.getObjectionsOrderMatchSucceeded(matches));
  } catch (err) {
    yield put(actions.getObjectionsOrderMatchFailed());
  }
}
function* getObjections(action) {
  try {
    const res = yield call(apiGetObjections, action.payload);

    let data = res.data.items.reduce((acc, value) => {
      acc.push({
        id: value.id,
        organizationId: value.exchangeOrderDto.organizationId,
        organizationName: value.organizationName,
        matchTotalAmount: value?.matchBundle?.matchTotalAmount,
        orderTotalBuyAmount: value?.matchBundle?.orderTotalBuyAmount,
        contractName: value.matchBundle.matchList[0].yekgcontract.contractName,
        matchTime: moment(value.matchBundle.matchList[0].createdDate).format(
          "DD.MM.YYYY HH:mm:ss"
        ),
        orderTime: moment(value.exchangeOrderDto.givenAt).format(
          "DD.MM.YYYY HH:mm:ss"
        ),
        objectionTime: moment(value.createdAt).format("DD.MM.YYYY HH:mm:ss"),
        orderId: value.exchangeOrderDto.orderGroupDto.id,
        orderPrice: value.exchangeOrderDto.price,
        orderAmount:
          value.organizationName ===
          value.matchBundle.matchList[0].buyOrder.organizationName
            ? value.matchBundle.matchList[0].matchBuyAmount
            : value.matchBundle.matchList[0].matchSellAmount,
        quantityAdmin:
          value?.objectedOrganizationId ===
          value?.matchBundle?.buyOrganizationId
            ? value?.matchBundle?.orderTotalBuyAmount
            : value?.matchBundle?.orderTotalSellAmount,
        matchPrice: value.matchBundle.matchList[0].price,
        matchAmount: value.matchBundle.matchList[0].amount,
        orderType: value.exchangeOrderDto.orderType,
        userName: value.username,
        userEmail: value.userEmail,
        userTel: value.userTel,
        details: value,
        answeredBy: value.answeredBy,
        answeredAt: moment(value.answeredAt).format("DD.MM.YYYY HH:mm:ss"),
      });
      return acc;
    }, []);
    yield put(actions.getObjectionsSucceeded(data));
  } catch (err) {
    yield put(actions.getObjectionsFailed());
  }
}
function* getObjectionsHistory(action) {
  try {
    const organizationId = action.payload;

    const res = yield call(apiGetObjectionsHistory, action.payload);

    let data = res.data.items.reduce((acc, value) => {
      acc.push({
        id: value.id,
        organizationId: value.exchangeOrderDto.organizationId,
        organizationName: value.organizationName,
        contractName: value?.exchangeOrderDto?.contractName,
        matchTotalAmount: value?.matchBundle?.matchTotalAmount,
        orderTotalBuyAmount: value?.matchBundle?.orderTotalBuyAmount,
        quantity:
          value?.matchBundle?.buyOrganizationId ===
          organizationId.organization.organizationId
            ? value?.matchBundle?.orderTotalBuyAmount
            : value?.matchBundle?.orderTotalSellAmount,
        quantityAdmin:
          value?.objectedOrganizationId ===
          value?.matchBundle?.buyOrganizationId
            ? value?.matchBundle?.orderTotalBuyAmount
            : value?.matchBundle?.orderTotalSellAmount,
        matchTime: moment(value.matchBundle.matchList[0].createdDate).format(
          "DD.MM.YYYY HH:mm:ss"
        ),
        orderTime: moment(value.exchangeOrderDto.givenAt).format(
          "DD.MM.YYYY HH:mm:ss"
        ),
        objectionTime: moment(value.createdAt).format("DD.MM.YYYY HH:mm:ss"),
        orderId: value.exchangeOrderDto.orderGroupDto.id,
        orderPrice: value.exchangeOrderDto.price,
        orderAmount: value.exchangeOrderDto.amount,
        matchPrice: value.matchBundle.matchList[0].price,
        matchAmount: value.matchBundle.matchList[0].amount,
        orderType: value.exchangeOrderDto.orderType,
        objectionDescription: value.note,
        answer: value.answer,
        status: value.objectionStatus,
        userName: value.username,
        userEmail: value.userEmail,
        userTel: value.userTel,
        details: value,
        answeredBy: value.answeredBy,
        answeredAt: moment(value.answeredAt).format("DD.MM.YYYY HH:mm:ss"),
      });
      return acc;
    }, []);
    yield put(
      actions.getObjectionsHistorySucceeded({
        data,
        total: {
          totalItemCount: res.data.totalItemCount,
          totalPageCount: res.data.totalPageCount,
        },
      })
    );
  } catch (err) {
    yield put(actions.getObjectionsHistoryFailed());
  }
}

export default function* offerSaga() {
  yield all([
    fork(watchGetObjectionsOrderMatch),
    fork(watchGetObjectionsRequested),
    fork(watchGetObjectionsHistoryRequested),
  ]);
}

function apiGetObjectionsOrderMatch(organizationId) {
  return API_GET("objections/orderMatch/search", {
    buyOrSellOrganizationId: organizationId,
    page: 0,
    size: 1000,
  });
}

function apiGetObjections(filter) {
  return API_GET("objections/search", {
    organizationId:
      filter.organization && filter.organization.organizationId
        ? filter.organization.organizationId
        : "",
    contractId:
      filter.contract && filter.contract !== "-" ? filter.contract : "",
    type: filter.type && filter.type !== "-" ? filter.type : "",
    objectionStatus: "INITIAL",
    page: 0,
    size: 1000,
  });
}
function apiGetObjectionsHistory(filter) {
  let status;
  if (filter.status)
    if (filter.status === "-") {
      status = ["ACCEPTED", "REJECTED"];
    } else if (filter.status === "all") {
      status = ["INITIAL", "ACCEPTED", "REJECTED"];
    } else {
      status = filter.status;
    }
  return API_GET("objections/search", {
    organizationId:
      filter.organization && filter.organization.organizationId
        ? filter.organization.organizationId
        : "",
    startDate: filter.startDate
      ? moment(filter.startDate).format("YYYYMMDD")
      : "",
    endDate: filter.endDate ? moment(filter.endDate).format("YYYYMMDD") : "",
    objectionStatus: status,
    page: filter?.page || 0,
    size: 10,
  });
}
